export default "__VITE_ASSET__z9d8T$Ly__"